import { device } from '@constants/mediaQueries';
import { styled, useMediaQuery } from '@mui/material';
import MUIList from '@mui/material/List';
import MUITypography from '@mui/material/Typography';
import type { Order, OrderItem } from '@partful/shared-types';
import useFormattedPrice from '@services/formatCurrency';
import { OrderItem as OrderItemComponent } from './OrderItem';
import { TotalDivider } from './styles';

type ReceivedOrderPartsListProps = {
  items: OrderItem[];
  totalPrice: Order['totalPrice'];
};

export default function OrderPartsList({ items, totalPrice }: Readonly<ReceivedOrderPartsListProps>) {
  const { currencyCode: currency, amount: price } = totalPrice;
  const isMobile = useMediaQuery(device.mobileOrTablet);

  return (
    <OrdersPartListWrapper>
      <OrderParts>
        {items.map((item) => (
          <OrderItemComponent
            key={item.partNumber}
            partName={item.partName}
            partNumber={item.partNumber}
            quantity={item.quantity}
            price={item.unitPrice}
            currency={currency}
          />
        ))}
      </OrderParts>
      <TotalDivider />
      <Total>
        <MUITypography fontWeight="bold">Total:</MUITypography>
        <MUITypography
          variant={isMobile ? /* istanbul ignore next */ 'h5' : 'h4'}
          fontWeight={{ xs: 'bold', md: 'normal' }}
          data-testid="shopping-cart-total-price"
        >
          {useFormattedPrice({ price, currency })}
        </MUITypography>
      </Total>
    </OrdersPartListWrapper>
  );
}

const OrdersPartListWrapper = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const OrderParts = styled(MUIList)`
  flex-grow: 1;
  width: 100%;
  color: ${({ theme }) => theme.palette.grey[900]};
  & li:nth-of-type(even) {
    background-color: ${({ theme }) => theme.palette.grey[100]};
  }

  overflow: auto;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  /* Chrome Safari Opera */
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Total = styled('div')`
  height: 80px;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-right: 2rem;
`;
